export default function resolveCompanyLogoUrl(
    registrationCompanyLogo?: string,
    infoLogo?: string,
): string | null {
    if (registrationCompanyLogo) {
        return registrationCompanyLogo;
    }

    if (infoLogo) {
        return infoLogo;
    }

    return null;
}
